import React from 'react';
import { Input } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/input.less';

export default Input;
